import { Component, OnInit, EventEmitter, AfterContentInit, Output, Input, OnChanges, SimpleChanges } from '@angular/core';
import { YoutubePlayerService } from './services/youtube-player.service';
import { YT } from './models/youtube';
const /** @type {?} */ domEleId = 'player';
export class YoutubePlayerComponent implements AfterContentInit {
   videoId: string;
   height: number;
   width: number;
   playerParams: YT.PlayerVars;

   playerReadyEvent = new EventEmitter<YT.Player>();
   playerStateChangeEvent = new EventEmitter<YT.PlayerState>();

  domId;
/**
 * @param {?} playerService
 */
constructor(private playerService: YoutubePlayerService) {
    this.domId = 'player-' + this.guid();
  }
/**
 * @return {?}
 */
ngAfterContentInit() {
    const /** @type {?} */ playerOptions: YT.PlayerOptions = {
      videoId: this.videoId || '',
      height: this.height || 300,
      width: this.width || 300,
      playerVars: {
        ...this.playerParams,
        enablejsapi: 1
      }
    };

    this.playerService.loadPlayerApi();
    this.playerService.createPlayer(this.domId, playerOptions, this.playerReadyEvent, this.playerStateChangeEvent);
  }
/**
 * @return {?}
 */
guid() {
/**
 * @return {?}
 */
function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'ng5-youtube-player',
  template: `
    <div [id]="domId"></div>
  `,
  styles: [`

  `]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: YoutubePlayerService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'videoId': [{ type: Input },],
'height': [{ type: Input },],
'width': [{ type: Input },],
'playerParams': [{ type: Input },],
'playerReadyEvent': [{ type: Output },],
'playerStateChangeEvent': [{ type: Output },],
};
}

function YoutubePlayerComponent_tsickle_Closure_declarations() {
/** @type {?} */
YoutubePlayerComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
YoutubePlayerComponent.ctorParameters;
/** @type {?} */
YoutubePlayerComponent.propDecorators;
/** @type {?} */
YoutubePlayerComponent.prototype.videoId;
/** @type {?} */
YoutubePlayerComponent.prototype.height;
/** @type {?} */
YoutubePlayerComponent.prototype.width;
/** @type {?} */
YoutubePlayerComponent.prototype.playerParams;
/** @type {?} */
YoutubePlayerComponent.prototype.playerReadyEvent;
/** @type {?} */
YoutubePlayerComponent.prototype.playerStateChangeEvent;
/** @type {?} */
YoutubePlayerComponent.prototype.domId;
/** @type {?} */
YoutubePlayerComponent.prototype.playerService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
